import { render } from "./InputTextModal.vue?vue&type=template&id=4efd84c1"
import script from "./InputTextModal.vue?vue&type=script&lang=ts"
export * from "./InputTextModal.vue?vue&type=script&lang=ts"
script.render = render

export default script